import type { LoaderFunctionArgs } from 'react-router';
import { supabase } from './supabase';
import { fetchItineraryBuilderData } from './itineraryQueries';

// Return a promise inside the loader result: start the request immediately,
// while the access guard and lazy route module load in parallel.
// The API independently authenticates and authorizes every request.
export function builderRouteLoader({ params, request }: LoaderFunctionArgs) {
  const builderData = (async () => {
    const { data: { session } } = await supabase.auth.getSession();
    const userId = session?.user.id;
    return {
      userId,
      data: params.id && userId
        ? await fetchItineraryBuilderData(params.id, request.signal, userId)
        : null,
    };
  })().catch(() => ({ userId: undefined, data: null }));
  return { builderData };
}
